<template>
	<!-- <p class="control has-icons-left">
		<input
			class="input is-rounded"
			type="text"
			v-model="value"
			:placeholder="placeholder"
			@keyup="search(value)"
		>
		<span class="icon is-small is-left">
			<i class="fa fa-search"></i>
		</span>
	</p> -->
	<div class="unishop-unifilter tienda-filtro">
    <div>
      <div class="uf-filter-wrap">
        <div id="uf-name" class="uf-search">
          <div class="uf-search-box">
            <input
              class="input is-rounded"
              type="text"
              v-model="nombre"
              placeholder="Nombre..."
            >
            <div class="uf-reset" title="Reset" @click="nombre=''">
            </div>
          </div>
        </div>
      </div>
      <div class="uf-filter-wrap">
        <div id="uf-category" class="uf-filter">
          <!-- <div class="uf-title">Temporada</div> -->
          <multiselect 
            v-model="temporadaSelect" 
            selected-label="Seleccionado"
            select-label=""
            deselect-label="Borrar"
            placeholder="Temporada" 
            label="nombre" 
            track-by="id" 
            :options="temporadas" 
            :multiple="true" 
            :taggable="false" 
          >
          </multiselect>
          <!-- <pre class="language-json"><code>{{ temporadaSelect  }}</code></pre> -->
        </div>
      </div>
      <div class="uf-filter-wrap" v-if="!isSys4Conjunto()">
        <div id="uf-category" class="uf-filter">
          <!-- <div class="uf-title">Color</div> -->
          <multiselect 
            v-model="colorSelect" 
            selected-label="Seleccionado"
            select-label=""
            deselect-label="Borrar"
            placeholder="Color" 
            label="descripcion" 
            track-by="id" 
            :options="colores" 
            :multiple="true" 
            :taggable="false" 
          >
          <template slot="option" slot-scope="props">
              <div class="option__desc"><div class="filter-color" :style="{'background' : '#' + props.option.rgb}">
                {{ props.option.title }}</div><span>{{ props.option.descripcion }}</span></div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="uf-filter-wrap" v-if="familias.length > 0"> 
        <div id="uf-category" class="uf-filter">
          <multiselect 
            v-model="familiaSelect" 
            selected-label="Seleccionado"
            select-label=""
            deselect-label="Borrar"
            placeholder="Familia" 
            label="descripcion" 
            track-by="id" 
            :options="familias" 
            :multiple="true" 
            :taggable="false" 
          >
          </multiselect>
        </div>
      </div>
      <div class="uf-filter-wrap" v-if="tallas.length > 0"> 
        <div id="uf-category" class="uf-filter">
          <multiselect 
            v-model="tallasSelect" 
            selected-label="Seleccionado"
            select-label=""
            deselect-label="Borrar"
            placeholder="Tallas" 
            label="" 
            track-by="" 
            :options="tallas" 
            :multiple="true" 
            :taggable="false" 
          >
          </multiselect>
        </div>
      </div>
      <div class="uf-filter-wrap">
        <div id="uf-category" class="uf-filter">
          <!-- <div class="uf-title">Sección</div> -->
              <v-treeview
              selectable
              return-object
              :value="seccionesSelect"
              v-model="seccionesSelect"
              selected-color="#2562a4"
              :items="secciones"
              item-children="secciones"
              item-key="id"
              item-text="descripcion"
            ></v-treeview>
          </div>
      </div>
      <div class="uf-range-wrap" v-show="false">
        <div id="uf-price" class="uf-range">
          <v-checkbox
            v-model="stockOnline"
            color="#2562a4"
            hide-details
          ><template v-slot:label>
              <div class="filter-check-label">Stock tienda online</div>
            </template>
          </v-checkbox>
        </div>
      </div>
      <div class="uf-filter-wrap">
        <div id="uf-category" class="uf-filter">
          <div class="uf-title"></div>
          <multiselect 
            v-model="tiendaSelect" 
            selected-label="Seleccionado"
            select-label=""
            deselect-label="Borrar"
            placeholder="Stock en tienda" 
            label="msopclicode" 
            track-by="msopid" 
            :options="tiendas"
            :custom-label="customLabel"
            :multiple="false" 
            :taggable="false" 
          >
          </multiselect>
        </div>
      </div>
      <div class="uf-range-wrap">
        <div id="uf-price" class="uf-range">
          <!-- <div class="uf-title">Precio</div> -->
          <!-- <vue-slider v-model="precio" :enable-cross="false" :tooltip="'always'" :min="10" :max="200" :width="200"
            @drag-end="searchPrice()"></vue-slider> -->
          <vue-slider class="ml-10" v-model="precio" :enable-cross="false" :tooltip="'always'" :min="precioInicial[0]" :max="precioInicial[1]" ></vue-slider>
        </div>
      </div>
      
      <!-- <div class="uf-sort-wrap">
        <div class="uf-sort">
          <div class="uf-title">Sort</div>
          <div class="uf-sort-box">
            <div class="uf-select">
              <span>Sort by …</span>
              <a class="uf-order" href="#" title="Reverse sorting order"></a>
            </div>
            <ul class="uf-options">
              <li><a href="#rating">Rating</a></li>
              <li><a href="#price">Price</a></li>
              <li><a href="" title="Click to reset sorting">None</a></li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
    <div class="d-flex justify-end filter-button">
        <v-btn icon  class="primary no-flex" @click="reset()"><v-icon>restart_alt</v-icon></v-btn>
        <v-btn fab flat class="orange white--text no-flex mx-0" @click="search()"><v-icon>search</v-icon></v-btn>
    </div>
	</div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import VueSlider from 'vue-slider-component'

import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'

const tiendaApiService = new TiendaApiService()
const util = new Util()

export default {
	name: 'filtro',
	components: {
    VueSlider,Multiselect
  },
  props: ['opId'],
	data () {
		return {
      precio: [],
      precioInicial: [0, 0],
      temporadas: [],
      temporadaSelect: [],
      secciones: [],
      seccionesSelect:[],
      tallas: [],
      tallasSelect: [],
      colores:[],
      familias:[],
      colorSelect: [],
      familiaSelect: [],
      stockOnline: false,
      tiendas: this.$store.state.iniOps,
      tiendaSelect: [],
      nombre: '',
		}
	},

	computed: {
		placeholder () {
			if (this.$route.path === '/wishlist') {
				return 'Search in wishlist...';
			} else {
				return 'Buscar...';
			}
		},
    hasSearched () {
      return this.$store.state.userInfo.hasSearched;
    },
	},
  watch: {
    hasSearched (value) {
      if (value === 0) {
        this.reset()
      }
        
    }
  },
	mounted () {
    this.init()
    // console.log(this.tiendas)
    this.nombre = this.$store.state.userInfo.productTitleSearched
    this.precio = this.$store.state.userInfo.priceSearched
    this.temporadaSelect = this.$store.state.userInfo.productTemporadaSearched
    this.colorSelect = this.$store.state.userInfo.productColorSearched
    this.tallasSelect = this.$store.state.userInfo.productTallaSearched
    this.familiaSelect = this.$store.state.userInfo.productFamiliaSearched
    this.tiendaSelect = this.$store.state.userInfo.tiendaSearched
    this.stockOnline = this.$store.state.userInfo.stockOnlineSearched
		// this.seccionesSelect =this.$store.state.userInfo.productSeccionSearched
	},
	methods: {
    customLabel ({ msopclicode, msopnombre }) {
      return `${msopclicode} – ${msopnombre}`
    },
    init () {
      this.getAllTemporadas()
      this.getPrecioMinMax()
      this.getSecciones()
      // if (this.isSys4Conjunto()) {
      this.getTallas()
      // }
    },
		search () {
      this.$store.commit('setProductTitleSearched', this.nombre);
      // this.$store.commit('setProductTitleSearched', '');
      this.$store.commit('setProductLocalizadorSearched', '');
			// if (this.temporadaSelect.length > 0) {
			// 	this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
				this.$store.commit('setProductTemporadaSearched', this.temporadaSelect);
			// 	this.$store.commit('setProductPriceSearched', this.precio);
      // } 
      // if (this.seccionesSelect.length > 0) {
			// 	this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
				this.$store.commit('setProductSeccionSearched', this.seccionesSelect);
      //   this.$store.commit('setProductPriceSearched', this.precio);
      // } 
      // if (this.colorSelect.length > 0) {
				// this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
				this.$store.commit('setProductColorSearched', this.colorSelect);
        // this.$store.commit('setProductPriceSearched', this.precio);
      // } 
      this.$store.commit('setProductFamiliaSearched', this.familiaSelect);
      this.$store.commit('setProductTallaSearched', this.tallasSelect);
      this.$store.commit('setStockOnlineSearched', this.stockOnline);
      this.$store.commit('setTiendaSearched', this.tiendaSelect);
      this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
      this.$store.commit('setProductPriceSearched', this.precio);
      this.$store.commit('cambioPag', 1)
      this.$store.commit('showFiltro', false);
		},
		reset () {
      this.precio = this.precioInicial
      this.nombre = ''
      this.temporadaSelect = []
      this.seccionesSelect = []
      this.familiaSelect = []
      this.colorSelect = []
      this.tiendaSelect = []
      this.tallasSelect = []
      this.stockOnline = false
      this.$store.commit('setProductTitleSearched', '')
      this.$store.commit('setProductTemporadaSearched', [])
      this.$store.commit('setProductSeccionSearched', [])
      this.$store.commit('setProductColorSearched', [])
      this.$store.commit('setProductTallaSearched', [])
      this.$store.commit('setProductFamiliaSearched', [])
      this.$store.commit('setTiendaSearched', []);
      this.$store.commit('setStockOnlineSearched', false)
			this.$store.commit('cambioPag', 1)
      this.$store.commit('setHasUserSearched', 0)
      // this.$store.commit('showFiltro', false)
      this.$forceUpdate()
      
    },
    getAllTemporadas() {
      tiendaApiService.getAllTemporadas()
          .then(data => {
            if (data) {
              this.temporadas=data
            }
            else {   
              this.temporadas=[]
            }            
          })
          .catch(error => {
            util.mostrarEnConsola('tiendaApiService - getAllTemporadas', error, 'ERROR')
          })
    },
    getTallas() {
      tiendaApiService.getTallas()
          .then(data => {
            if (data) {
              this.tallas=data
            }
            else {   
              this.tallas=[]
            }            
          })
          .catch(error => {
            util.mostrarEnConsola('tiendaApiService - getTallas', error, 'ERROR')
          })
    },
    getPrecioMinMax () {
      tiendaApiService.getPrecioMinMax(this.opId)
        .then(data => {
          this.precioInicial = data
          if (this.precio.length === 0) {
            this.precio = this.precioInicial
          }
        })
        .catch(error => {
          util.mostrarEnConsola('tiendaApiService - getPrecioMinMax', error, 'ERROR')
        })
    },
    getSecciones () {
      tiendaApiService.getSecciones()
        .then(data => {
          var arrColores = [], arrFamilias = []
          // Sacamos a combo la sección de color que viene en enviroment
          Object.entries(data).forEach(function([key, value]){
            if (value.descripcion == process.env.VUE_APP_COLORDESC) {
              arrColores = data[key].secciones
              delete data[key]
            } else {
             value.id = value.id + '-SECCIONPADRE'
            }
          },arrColores);
          // Miramos por enviroment si la familia sale a combo
          if (process.env.VUE_APP_FAMILIADESC != 'false') {
            Object.entries(data).forEach(function([key, value]){
              if (value.descripcion == process.env.VUE_APP_FAMILIADESC) {
                arrFamilias = data[key].secciones
                delete data[key]
              } else {
              value.id = value.id + '-SECCIONPADRE'
              }
            },arrFamilias);
          }
          this.secciones = data
          this.colores = arrColores
          this.familias = arrFamilias
          // console.log(arrColores)
          // console.log(this.secciones)
          this.seccionesSelect =this.$store.state.userInfo.productSeccionSearched
        })
        .catch(error => {
          util.mostrarEnConsola('tiendaApiService - getSecciones', error, 'ERROR')
        })
    },
		// searchPrice(){
		// 	this.$store.commit('setHasUserSearched', true);
		// 	this.$store.commit('setProductPriceSearched', this.precio);
		// }
	}
}
</script>
<style>
.vue-slider.vue-slider-ltr {
    margin-top: 55px;
}
.vue-slider-dot-tooltip-text {
  cursor: pointer;
}
.multiselect__option--highlight {
  background: #2562a4 !important;
}
.multiselect__option--highlight:after {
  background: #2562a4 !important;
}
.multiselect__tag {
  background: #2562a4 !important;
}
.multiselect__spinner:before,
.multiselect__spinner:after {
  border-color: #2562a4 transparent transparent !important;
}
.vue-slider-process {
  background-color: #2562a4 !important;
}
.vue-slider-mark-step {
  background-color: #2562a4 !important;
}
.vue-slider-dot-handle {
  background-color: #2562a4 !important;
}
.vue-slider-dot-tooltip-inner {
  background-color: #2562a4 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>